import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, throwError, timeout } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
    urlPay =environment.apiPay
    url = environment.api

    reqHeader = new HttpHeaders();
    
    constructor(
        private http:HttpClient
    ) { }

    usePayService(tmp:any) {
      return this.http.post(`${this.urlPay}/button/V2/Confirm`, JSON.stringify(tmp), 
      { 
        headers: new HttpHeaders({"Content-Type": "application/json", "Authorization" : `Bearer ${environment.payphoneToken}`})
      })
      .pipe(
        timeout(60000), // 60 segundos
        catchError(error => {
          return throwError(() => error);
        })
      );
    }

    useApiServive(tmp:any) {
      return this.http.post(`${this.url}JBoxService.php`, JSON.stringify(tmp),
      {
        headers: new HttpHeaders({"Content-Type": "application/json"})
      })
      .pipe(
        timeout(60000), // 60 segundos
        catchError(error => {
          return throwError(() => error);
        })
      );
    }

    getResource(val:string){
      return this.http.get(`assets/json/${val}`,{ headers: this.reqHeader });
    }
}